import type {FunctionComponent} from 'react';
import {useMemo} from 'react';
import {useTranslation} from '@app/hooks/use-translation';

import {LandingSection} from '@tempo/landing';
import type {Article} from '@app/components/faq';
import {LandingSeoFaq} from '@app/components/faq';

export const FAQ: FunctionComponent = () => {
	const {t} = useTranslation();

	const articles = useMemo<Article[]>(
		() => [
			{
				title: t(
					'offlinelandingpagefaq_text_Qhowdoidownloadmusiconmyphone_standalone-web',
					{ns: 'offline'},
				),
				answer: [
					t(
						'offlinelandingpagefaq_text_Ahowdoidownloadmusiconmyphone_standalone-web',
						{ns: 'offline'},
					),
				],
			},
			{
				title: t(
					'offlinelandingpagefaq_text_Qwheredoesdeezerstoremydownloads_standalone-web',
					{
						ns: 'offline',
					},
				),
				answer: [
					t(
						'offlinelandingpagefaq_text_Awheredoesdeezerstoremydownloads_standalone-web',
						{ns: 'offline'},
					),
				],
			},
			{
				title: t(
					'offlinelandingpagefaq_text_Qhowdoidownloadpodcasts_standalone-web',
					{ns: 'offline'},
				),
				answer: [
					t(
						'offlinelandingpagefaq_text_Ahowdoidownloadpodcasts_standalone-web',
						{ns: 'offline'},
					),
				],
			},
		],
		[t],
	);
	return (
		<LandingSection isContained>
			<LandingSeoFaq articles={articles} />
		</LandingSection>
	);
};
